import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Row, Col, ControlLabel, Button, RadioGroup, Radio, Icon, Schema } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'
import {
  getProgressReportSubprojectClose,
  saveProgressRisk,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { getValueFromOptions } from '../../utils/dataUtil'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function ObstaclesAndRisksWidget({
  schema: _schema,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressReportsId,
  setProgressReportsId = () => {},
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [feedbackTroubleshootingValue, setFeedbackTroubleshootingValue] = useState([])
  const [deleteId, setDeleteId] = useState([])
  const [mapValues, setMapValues] = useState(new Map())
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
    setFeedbackTroubleshootingValue(_schema.values)
    setDataToMap(_schema?.values)
  }, [_schema])

  const setDataToMap = (value) => {
    var objMap = new Map()
    value?.forEach((e) => {
      objMap.set(e.id, e)
    })
    setMapValues(objMap)
  }

  const handleAdd = () => {
    let feedbackTroubleshootingVal = cloneDeep(feedbackTroubleshootingValue)
    let mapVal = cloneDeep(mapValues)
    let data = {
      id: 'addNew-' + uuidv4(),
      issues: '',
      problemSolving: '',
      troubleshooting: '',
    }
    feedbackTroubleshootingVal.push(data)
    mapVal.set(data.id, data)
    setMapValues(mapVal)

    setFeedbackTroubleshootingValue(feedbackTroubleshootingVal)
  }

  const handleDelete = (item, index) => {
    let feedbackTroubleshootingVal = cloneDeep(feedbackTroubleshootingValue)
    let mapVal = cloneDeep(mapValues)
    if (index > -1) {
      feedbackTroubleshootingVal.splice(index, 1)
    }
    if (!item.id.startsWith('addNew-')) {
      setDeleteId([...deleteId, item.id])
    }
    mapVal.delete(item.id)
    setMapValues(mapVal)
    setFeedbackTroubleshootingValue(feedbackTroubleshootingVal)
  }

  const shouldClearId = (id) => {
    return id.includes('addNew-') || id.includes('null')
  }

  const onSubmit = (data) => {
    let combinedData = []
    feedbackTroubleshootingValue?.forEach((i) => {
      let mapval = mapValues.get(i.id)

      combinedData.push({
        id: mapval?.id?.indexOf('addNew-') == -1 ? mapval.id : '',
        issues: mapval.issuesObstacles,
        problemSolving: mapval.feedbackTroubleshooting,
        troubleshooting: mapval.troubleshooting,
      })
    })

    const validateCommentId = (commentId) => {
      if (commentId === 'commentId_191875A2-EAD4-4621-B03F-255C998A110A') {
        return data[commentId] || null
      }
      return data[commentId]
    }

    const commentIds = Object.keys(data)
      .filter((key) => key.startsWith('commentId_'))
      .map((key) => ({
        key: key,
        value: validateCommentId(key),
      }))
      .filter((item) => item.value !== undefined)
      .map((item) => item.value)

    let currentCommentIdIndex = 0

    const riskOperationalReq = {
      riskOperationalLists: [],
      deleteRiskOperationalIds: [],
    }

    for (let key in data) {
      if (key.startsWith('OPR_') || key.startsWith('FIN_')) {
        const idComment = commentIds[currentCommentIdIndex]
        currentCommentIdIndex = (currentCommentIdIndex + 1) % commentIds.length

        const id = key
        const indicatorValue = parseInt(data[key])
        const riskSubjectCode = `CommentInput_${key}`
        const riskComment = data[riskSubjectCode]

        riskOperationalReq.riskOperationalLists.push({
          id: idComment,
          riskSubjectCode: id,
          indicatorValue: indicatorValue,
          riskComment: riskComment,
        })
      }
    }

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period,
      installmentPlanDetailId: installmentPlanId,
      riskActivitiesReq: {
        riskActivitiesLists: combinedData,
        deleteRiskActivitiesIds: deleteId || [],
      },
      riskOperationalReq: riskOperationalReq,
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveProgressRisk(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setDataToMap(response.forms.obstaclesAndRisks.values)
        setFeedbackTroubleshootingValue(response.forms.obstaclesAndRisks.values)
        setFormSchema(response.forms.obstaclesAndRisks)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded header={formSchema?.header} collapsible defaultExpanded>
        <Row style={{ marginTop: -20 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <div style={{ paddingLeft: 40, paddingRight: 25 }}>
              <div>
                <h6>{formSchema.subtitle}</h6>
              </div>
            </div>
          </Col>
        </Row>

        <div style={{ paddingLeft: 80, paddingRight: 80 }}>
          {feedbackTroubleshootingValue &&
            feedbackTroubleshootingValue.map((item, index) => {
              return (
                <>
                  <div style={{ marginBottom: 10 }}>
                    <Row style={{ marginTop: 20 }}>
                      <Col lg={11} md={11} sm={11} xs={11}>
                        {!disabled ? (
                          <>
                            <ControlLabel
                              className={classNames(
                                isRequired(formSchema.issuesObstaclesInput.validators) && 'required'
                              )}
                            >
                              {formSchema.issuesObstaclesInput.label}
                            </ControlLabel>

                            <InputForm
                              schema={formSchema.issuesObstaclesInput}
                              name={`${formSchema.issuesObstaclesInput.name}_${item.id}`}
                              // placeholder={'ระบุ' + formSchema.issuesObstaclesInput.placeholder}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              hideLabel={true}
                              value={
                                mapValues?.get(item.id)?.issuesObstacles || item.issuesObstacles
                              }
                              onChange={(value) => {
                                let nObj = cloneDeep(mapValues)
                                nObj.get(item.id).issuesObstacles = value
                                setMapValues(nObj)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <b> {formSchema.issuesObstaclesInput.label}</b>
                            <p>{mapValues?.get(item.id)?.issuesObstacles}</p>
                          </>
                        )}
                      </Col>
                      <Col lg={11} md={11} sm={11} xs={11}>
                        {!disabled ? (
                          <>
                            <ControlLabel
                              className={classNames(
                                isRequired(formSchema.troubleshootingInput.validators) && 'required'
                              )}
                            >
                              {formSchema.troubleshootingInput.label}
                            </ControlLabel>

                            <InputForm
                              schema={formSchema.troubleshootingInput}
                              name={`${formSchema.troubleshootingInput.name}_${item.id}`}
                              // placeholder={'ระบุ' + formSchema.troubleshootingInput.placeholder}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              hideLabel={true}
                              value={
                                mapValues?.get(item.id)?.troubleshooting || item.troubleshooting
                              }
                              onChange={(value) => {
                                let nObj = cloneDeep(mapValues)
                                nObj.get(item.id).troubleshooting = value
                                setMapValues(nObj)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <b> {formSchema.troubleshootingInput.label}</b>
                            <p>{mapValues?.get(item.id)?.troubleshooting}</p>
                          </>
                        )}
                      </Col>
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    </Row>

                    <Row style={{ marginTop: 20 }}>
                      <Col lg={22} md={22} sm={22} xs={22}>
                        {!disabled ? (
                          <>
                            <ControlLabel
                              className={classNames(
                                isRequired(formSchema.feedbackTroubleshootingInput.validators) &&
                                  'required'
                              )}
                            >
                              {formSchema.feedbackTroubleshootingInput.label}
                            </ControlLabel>
                            <InputForm
                              schema={formSchema.feedbackTroubleshootingInput}
                              name={`${formSchema.feedbackTroubleshootingInput.name}_${item.id}`}
                              // placeholder={
                              //   'ระบุ' + formSchema.feedbackTroubleshootingInput.placeholder
                              // }
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              hideLabel={true}
                              value={
                                mapValues?.get(item.id)?.feedbackTroubleshooting ||
                                item.feedbackTroubleshooting
                              }
                              onChange={(value) => {
                                let nObj = cloneDeep(mapValues)
                                nObj.get(item.id).feedbackTroubleshooting = value
                                setMapValues(nObj)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <b> {formSchema.feedbackTroubleshootingInput.label}</b>
                            <p>{mapValues?.get(item.id)?.feedbackTroubleshooting}</p>
                            <hr />
                          </>
                        )}
                      </Col>
                      {!disabled ? (
                        <Col lg={2} md={2} sm={2} xs={2}>
                          {feedbackTroubleshootingValue.length > 1 && (
                            <div style={{ marginTop: 33 }}>
                              <Button color="red" onClick={() => handleDelete(item, index)}>
                                ลบ
                              </Button>
                            </div>
                          )}

                          {feedbackTroubleshootingValue.length == index + 1 && (
                            <>
                              <div style={{ marginTop: 33 }}>
                                <Button color="blue" onClick={() => handleAdd()}>
                                  เพิ่ม
                                </Button>
                              </div>
                            </>
                          )}
                        </Col>
                      ) : (
                        <Col lg={2} md={2} sm={2} xs={2}></Col>
                      )}
                    </Row>
                  </div>
                </>
              )
            })}
        </div>

        {formSchema?.inputRisk?.length > 0 &&
          formSchema?.inputRisk.map((item, index) => {
            return (
              <Row style={{ marginTop: 20 }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                    <div>
                      <h6>{item.title}</h6>
                    </div>
                    {item?.input?.length > 0 &&
                      item?.input.map((item, index) => {
                        return (
                          <>
                            <div style={{ paddingLeft: 80, paddingRight: 80, marginTop: 20 }}>
                              <Row>
                                <Col lg={23} md={23} sm={23} xs={23}>
                                  <ErrorMessage
                                    error={
                                      errors[
                                        `${formSchema?.inputRisk[index]?.input[index]?.name}_${index}`
                                      ]
                                    }
                                  />
                                  {!disabled ? (
                                    <>
                                      <ControlLabel
                                        className={classNames(
                                          isRequired(item.validators) && 'required'
                                        )}
                                      >
                                        {item.label}
                                      </ControlLabel>
                                      <Controller
                                        name={item.name}
                                        defaultValue={item.value ? String(item.value) : null}
                                        rules={isValidators(
                                          formSchema?.inputRisk[index]?.input[index]?.validators
                                        )}
                                        control={control}
                                        render={(props) => {
                                          const renderValue = parseInt(props.value, 10)
                                          return (
                                            <RadioGroup
                                              inline
                                              value={renderValue}
                                              onChange={(value) => {
                                                const returnValue = String(value)
                                                props.onChange(returnValue)
                                              }}
                                            >
                                              {item.options.map((item, index) => {
                                                return (
                                                  <>
                                                    <Radio
                                                      key={index}
                                                      value={parseInt(item.value, 10)}
                                                    >
                                                      {item.label}
                                                    </Radio>
                                                  </>
                                                )
                                              })}
                                            </RadioGroup>
                                          )
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <b> {item.label}</b>
                                      <p>
                                        <Icon
                                          icon="dot-circle-o"
                                          style={{ marginRight: 5, color: '#14997a' }}
                                        />
                                        {`${getValueFromOptions(
                                          item.options.map((item, index) => {
                                            return {
                                              ...item,
                                              value: item.value.toString(),
                                            }
                                          }),
                                          item.value || '0'
                                        )}`}
                                      </p>
                                    </>
                                  )}
                                </Col>
                                <Col lg={1} md={1} sm={1} xs={1}></Col>
                                <Col lg={23} md={23} sm={23} xs={23}>
                                  {!disabled ? (
                                    <>
                                      <ControlLabel>{item.commentInput.label}</ControlLabel>
                                      <InputForm
                                        schema={item.commentInput}
                                        name={item.commentInput.name}
                                        value={item.commentInput.value}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        clearErrors={clearErrors}
                                        hideLabel={true}
                                        placeholder={'ระบุ' + item.commentInput.label}
                                        onChange
                                      />
                                    </>
                                  ) : (
                                    <div style={{ marginTop: 10 }}>
                                      <b>{item.commentInput.label}</b>
                                      <p>{item.commentInput.value}</p>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                              <Row style={{ display: 'none' }}>
                                <Col lg={24} md={24} sm={24} xs={24}>
                                  {/* <div style={{ marginTop: 10 }}>
                                    <span>{item.id}</span>
                                  </div> */}
                                  <InputForm
                                    schema={item.id}
                                    // name={item.id}
                                    name={`${'commentId'}_${item.id}`}
                                    value={item.id}
                                    register={register}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    setValue={setValue}
                                    clearErrors={clearErrors}
                                    hideLabel={true}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </>
                        )
                      })}
                  </div>
                </Col>
              </Row>
            )
          })}

        {formSchema.resultRisks && (
          <>
            <div style={{ paddingLeft: 40, paddingRight: 25 }}>
              <Row style={{ marginTop: 20 }}>
                <Col lg={10} md={10} sm={10} xs={10} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 15 }}>
                    <ControlLabel>{`${formSchema.resultRisks.score.label} : `}</ControlLabel>
                  </div>
                </Col>
                <Col lg={1} md={1} sm={1} xs={1}>
                  <div style={{ marginTop: 15 }}>
                    <ControlLabel>
                      {/* {formSchema.resultRisks.score.value
                        ? `${formSchema.resultRisks.score.value} `
                        : ''} */}
                      {formSchema.resultRisks.score.value !== undefined &&
                      formSchema.resultRisks.score.value !== null
                        ? `${formSchema.resultRisks.score.value}`
                        : ''}
                    </ControlLabel>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'left' }}>
                  <div style={{ marginTop: 15 }}>
                    <ControlLabel>{`${formSchema.resultRisks.score.unit}`}</ControlLabel>
                  </div>
                </Col>
                <Col lg={9} md={9} sm={9} xs={9}></Col>
              </Row>

              <Row>
                <Col lg={10} md={10} sm={10} xs={10} style={{ textAlign: 'right' }}>
                  <div style={{ marginTop: 15 }}>
                    <ControlLabel>{`${formSchema.resultRisks.level.label} : `}</ControlLabel>
                  </div>
                </Col>
                <Col lg={14} md={14} sm={14} xs={14}>
                  <div style={{ marginTop: 15 }}>
                    <ControlLabel>
                      {formSchema.resultRisks.level.value
                        ? `${formSchema.resultRisks.level.value} `
                        : ''}
                    </ControlLabel>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}
        {!disabled && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </>
  )
}
